import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import logo from "../assets/logo.png";
import { API_BASE_URL } from "../config";

const isCleaning = window.location.pathname.startsWith("/cleaning");
const isPoolCare = window.location.pathname.startsWith("/poolcare");
const SwapDeal = () => {
  const { dealId } = useParams();

  const [deal, setDeal] = useState(null);
  const [listingA, setListingA] = useState(null);
  const [listingB, setListingB] = useState(null);
  const [userA, setUserA] = useState(null);
  const [userB, setUserB] = useState(null);

  const [loading, setLoading] = useState(true);

  const [myConfirm, setMyConfirm] = useState(0);
  const [otherConfirm, setOtherConfirm] = useState(0);
  const [handoverStatus, setHandoverStatus] = useState(null);

  const userId = Number(localStorage.getItem("userId"));


  /* ============================================================
        LOAD DEAL DETAILS
  ============================================================ */
 const loadDeal = async () => {
  try {
    const token = localStorage.getItem("token");

const res = await axios.get(
  isCleaning
    ? `${API_BASE_URL}/api/cleaning/swaps/deal/${dealId}`
    : isPoolCare
    ? `${API_BASE_URL}/api/poolcare/swaps/deal/${dealId}`
    : `${API_BASE_URL}/api/swap-deals/deal/${dealId}`,
  {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
);


    if (!res.data.success) return;

    const d = res.data.deal;
    setDeal(d);

    /* =============================
       LOAD LISTING A + OWNER
    ==============================*/
    if (d.listingA) {
      try {
        const A = await axios.get(
          `${API_BASE_URL}/api/swap-listings/${d.listingA}`
        );
        setListingA(A.data.listing);
        setUserA(A.data.owner);
      } catch (err) {
        console.error("Failed loading Listing A:", err);
      }
    }

    /* =============================
       LOAD LISTING B + OWNER
    ==============================*/
    if (d.listingB) {
      try {
        const B = await axios.get(
          `${API_BASE_URL}/api/swap-listings/${d.listingB}`
        );
        setListingB(B.data.listing);
        setUserB(B.data.owner);
      } catch (err) {
        console.error("Failed loading Listing B:", err);
      }
    }

    /* =============================
       CONFIRM STATUS + WHO AM I
    ==============================*/
    const isA = userId === d.userA;
    const mine = isA ? d.confirmA : d.confirmB;
    const other = isA ? d.confirmB : d.confirmA;

    setMyConfirm(mine);
    setOtherConfirm(other);

    if (mine === 0 && other === 0) {
      setHandoverStatus("pending");
    } else if (mine === 1 && other === 0) {
      setHandoverStatus("waiting");
    } else if (mine === 0 && other === 1) {
      setHandoverStatus("partner_confirmed");
    } else if (mine === 1 && other === 1) {
      setHandoverStatus("completed");
    }

    setLoading(false);
  } catch (err) {
    console.error("Failed loading deal:", err);
    setLoading(false);
  }
};




  useEffect(() => {
    loadDeal();
  }, [dealId]);

  useEffect(() => {
    const interval = setInterval(() => {
      loadDeal();
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  /* ============================================================
      CONFIRM HANDOVER
============================================================ */
const confirmHandover = async () => {
  try {
    const token = localStorage.getItem("token");

const res = await axios.post(
  isCleaning
    ? `${API_BASE_URL}/api/cleaning/swaps/confirm-handover/${deal.id}`
    : isPoolCare
    ? `${API_BASE_URL}/api/poolcare/swaps/confirm-handover/${deal.id}`
    : `${API_BASE_URL}/api/swap-deals/confirm-handover/${deal.id}`,
      {}, // 🔒 DO NOT send userId anymore
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (res.data.success) {
      loadDeal(); // safer than manual state patching
    }

  } catch (err) {
    console.error("❌ Confirm handover failed:", err);
    alert("Failed to confirm handover. Please try again.");
  }
};



  /* ============================================================
        EARLY RETURNS
  ============================================================ */
  if (loading) return <p>Loading...</p>;
  if (!deal) return <p>Deal not found.</p>;

 const isUserA = deal.userA === userId;
const isUserB = deal.userB === userId;

const userPaid =
  (isUserA && deal.paymentA === 1) ||
  (isUserB && deal.paymentB === 1);

const otherPaid =
  (isUserA && deal.paymentB === 1) ||
  (isUserB && deal.paymentA === 1);



  /* ============================================================
        STATUS LOGIC
  ============================================================ */
  let status = "";
  let showPayButton = false;

  if (
  deal.swap_status === "payment_pending" ||
  deal.swap_status === "payment_required"
) {

    if (!userPaid && !otherPaid) {
      status = "Both users must pay before the swap can begin.";
      showPayButton = true;
    } else if (!userPaid && otherPaid) {
      status = "The other user has paid. Please pay to proceed.";
      showPayButton = true;
    } else if (userPaid && !otherPaid) {
      status = "Waiting for the other user to pay.";
    }
  }

  if (deal.swap_status === "handover") {
    if (myConfirm === 0) {
      status = "Both users have paid. Confirm handover once complete.";
    } else if (myConfirm === 1 && otherConfirm === 0) {
      status = "You have confirmed your handover.";
    } else if (myConfirm === 1 && otherConfirm === 1) {
      status = "Swap completed successfully!";
    }
  }

  if (deal.swap_status === "completed") {
    status = "Swap completed successfully!";
  }

  /* ============================================================
        STYLES
  ============================================================ */
  const pageStyle = { padding: "20px", maxWidth: "900px", margin: "0 auto" };
  const cardStyle = {
    background: "#ffffff",
    padding: "22px",
    borderRadius: "14px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
    marginBottom: "25px",
    border: "1px solid #e0e0e0",
  };

  const notifStyle = {
    marginTop: "12px",
    padding: "14px",
    background: "#e8f5e9",
    border: "1px solid #c8e6c9",
    borderRadius: "8px",
    color: "#1b5e20",
    fontWeight: "600",
    textAlign: "center",
    fontSize: "15px",
  };

  const infoRow = { marginBottom: "6px", fontSize: "15px" };

  /* ============================================================
        LISTING CARD (UNCHANGED)
  ============================================================ */
  const ListingCard = ({ title, listing, owner }) => {
    if (!listing) return null;

    return (
      <div style={cardStyle}>
        <h3
          style={{
            fontSize: "20px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            fontWeight: "600",
          }}
        >
          <span>{title}</span>
          <span
            style={{
              background: "#f0f0f0",
              padding: "6px 14px",
              borderRadius: "18px",
              fontSize: "13px",
              border: "1px solid #d0d0d0",
              color: "#444",
            }}
          >
            SWAP ID: {listing.listingId}
          </span>
        </h3>

        {/* Owner details remain locked until both paid */}
        {!userPaid || !otherPaid ? (
          <div
            style={{
              padding: "12px",
              background: "#fff8e1",
              borderRadius: "10px",
              marginBottom: "15px",
              border: "1px solid #ffe29a",
              color: "#946200",
            }}
          >
            Owner details will unlock once both parties have paid.
          </div>
        ) : (
          <div
            style={{
              padding: "12px",
              background: "#f7f7f7",
              borderRadius: "10px",
              marginBottom: "15px",
            }}
          >
            <p style={infoRow}>
              <strong>Name:</strong> {owner?.first_name} {owner?.last_name}
            </p>
            <p style={infoRow}>
              <strong>Company:</strong> {owner?.companyName || "N/A"}
            </p>
            <p style={infoRow}>
              <strong>ABN:</strong> {owner?.abn || "N/A"}
            </p>
            <p style={infoRow}>
              <strong>Email:</strong> {owner?.email || "N/A"}
            </p>
            <p style={infoRow}>
              <strong>Phone:</strong> {owner?.phone || "N/A"}
            </p>
          </div>
        )}

     <div
  style={{
    background: "#f8faf8",
    border: "1px solid #e1e8e1",
    borderRadius: "10px",
    padding: "16px",
    marginTop: "15px",
  }}
>
  <p style={infoRow}>
    <strong>From:</strong> {listing.swap_from_suburb}
  </p>

  <p style={infoRow}>
    <strong>To:</strong> {listing.swap_to_suburb}
  </p>
</div>
    
     
      </div>
    );
  };

  /* ============================================================
        PAGE RENDER + NEW HANDOVER SECTION
  ============================================================ */
  return (
    <div style={pageStyle}>
      <img
        src={logo}
        alt="Client Exchange Logo"
        style={{ width: "170px", display: "block", margin: "0 auto 20px" }}
      />

      {/* ================== STATUS CARD ================== */}
      <div style={cardStyle}>
        <h2 style={{ fontSize: "20px", fontWeight: "600" }}>Swap Status</h2>

        <p style={{ fontSize: "17px", marginBottom: "12px" }}>{status}</p>

        {/* Payment Button */}
{showPayButton && (
  <button
    style={{
      background: "#2e7d32",
      color: "white",
      padding: "14px 26px",
      borderRadius: "8px",
      fontSize: "16px",
      border: "none",
      marginTop: "10px",
    }}
   onClick={() => {
  const token = localStorage.getItem("token");

const endpoint = isCleaning
  ? `${API_BASE_URL}/api/cleaning/swaps/pay`
  : isPoolCare
  ? `${API_BASE_URL}/api/poolcare/swaps/pay`
  : `${API_BASE_URL}/api/swaps/swap-payments/create-session`;

  axios.post(
    endpoint,
    { dealId: deal.id }, // 🔒 ONLY send dealId
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  )
  .then((res) => {
    if (res.data.url) {
      window.location.href = res.data.url;
    }
  })
  .catch((err) => {
    console.error("Payment session error:", err);
  });
}}


  >
    Pay Swap Fee
  </button>
)}


        {/* ======================================================
           NEW HANDOVER SECTION (REPLACES OLD UI)
        ====================================================== */}
        {deal.swap_status === "handover" && (
          <div>
            {/* Swap Deal Summary Card */}
            <div
              style={{
                marginTop: "20px",
                padding: "18px",
                background: "#f7f7f7",
                borderRadius: "10px",
                border: "1px solid #ddd",
              }}
            >
              <h3 style={{ marginBottom: "10px", color: "#1b5e20" }}>
                Swap Deal Information
              </h3>

              <p><strong>Deal ID:</strong> {deal.id}</p>
              <p><strong>Swap Reference:</strong> {deal.swap_reference}</p>
              <p><strong>Listing A:</strong> {listingA?.listingId}</p>
              <p><strong>Listing B:</strong> {listingB?.listingId}</p>
            </div>

            {/* Confirm Button */}
            {myConfirm === 0 && (
              <button
                onClick={confirmHandover}
                style={{
                  background: "#2e7d32",
                  color: "white",
                  padding: "14px 26px",
                  borderRadius: "8px",
                  fontSize: "16px",
                  border: "none",
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                Confirm Handover
              </button>
            )}

            {/* Waiting Message */}
            {handoverStatus === "waiting" && (
              <div
                style={{
                  marginTop: "12px",
                  padding: "14px",
                  background: "#fff3cd",
                  border: "1px solid #ffeeba",
                  borderRadius: "8px",
                  color: "#8a6d3b",
                  fontWeight: "600",
                  textAlign: "center",
                  fontSize: "15px",
                }}
              >
                ✔ You have confirmed your handover.
                <br />
                ⏳ Waiting for your swap partner to confirm.
              </div>
            )}

            {/* Completed Message */}
            {handoverStatus === "completed" && (
              <div style={notifStyle}>
                ✔ Both users have confirmed.
                <br />
                🎉 Handover completed!
                <br />
                <strong>You may now safely close this page.</strong>
              </div>
            )}
          </div>
        )}
      </div>

      {/* PAYMENT STATUS */}
      <div
        style={{
          background: "#fff",
          padding: "20px",
          borderRadius: "10px",
          border: "1px solid #e0e0e0",
          marginBottom: "20px",
        }}
      >
        <h3 style={{ marginBottom: "15px", color: "#1b5e20" }}>
          Payment Status
        </h3>

        <div
          style={{
            padding: "12px 15px",
            borderRadius: "8px",
            marginBottom: "10px",
            background: "#e8f5e9",
            border: userPaid ? "1px solid #2e7d32" : "1px solid #ccc",
          }}
        >
          <strong>You:</strong>
          <span style={{ float: "right" }}>
            {userPaid ? "✔️ Paid" : "❌ Not Paid"}
          </span>
        </div>

        <div
          style={{
            padding: "12px 15px",
            borderRadius: "8px",
            background: "#fafafa",
            border: otherPaid ? "1px solid #2e7d32" : "1px solid #ccc",
          }}
        >
          <strong>Other User:</strong>
          <span style={{ float: "right" }}>
            {otherPaid ? "✔️ Paid" : "⏳ Waiting"}
          </span>
        </div>
      </div>

      <h2 style={{ fontSize: "20px", fontWeight: "600" }}>
        Your Swap Listings
      </h2>

    <ListingCard
  title={isUserA ? "Your Listing" : "Swap Partner Listing"}
  listing={listingA}
  owner={userA}
/>

<ListingCard
  title={isUserA ? "Swap Partner Listing" : "Your Listing"}
  listing={listingB}
  owner={userB}
/>
    </div>
  );
};

export default SwapDeal;
